import { useEffect, useState } from 'react'
import { callApi } from '@/utils/http-utils'

type AnyRecord = Record<string, any>

export const useModalityById = (id?: string) => {
  const [item, setItem] = useState<AnyRecord | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    if (!id) return
    ;(async () => {
      try {
        const res = await callApi(`/data-api/modalities/${encodeURIComponent(id)}`, { method: 'GET' })
        const ct = res.headers.get('content-type') || ''
        if (!ct.includes('application/json')) {
          const text = await res.text()
          throw new Error(`Expected JSON but got ${ct}. ${text.slice(0, 200)}`)
        }
        const body = await res.json()
        const obj = body?.item ?? body?.data ?? body?.result ?? body ?? null
        setItem(obj)
      } catch (e: any) {
        setError(e.message || 'Failed to fetch modality')
      } finally {
        setLoading(false)
      }
    })()
  }, [id])

  return { item, loading, error }
}
